export type SubjectKind = 'fundraiserPage' | 'teamPage' | 'collectionPage' | 'blob';

export type BlobMediaKind = 'image' | 'json' | 'pdf';

export type Band = 'autoApprove' | 'humanReview' | 'autoBlock';

export type AiCategory =
  | 'pharma'
  | 'crypto'
  | 'counterfeit'
  | 'phishing'
  | 'romance'
  | 'hate'
  | 'adult'
  | 'seoFarm'
  | 'airline'
  | 'legitimate'
  | 'other'
  | 'error';

export type TriggerReason =
  | 'created'
  | 'pageNameChanged'
  | 'pageBodyChanged'
  | 'pageMainImageChanged'
  | 'pageAboutImageChanged'
  | 'pageUrlChanged'
  | 'pageTeamChanged'
  | 'manual'
  | 'rescore'
  | 'blobUploaded'
  | 'multipleChanges';

export type DecisionType = 'approve' | 'block';

export type DisagreementReason =
  | 'aiMissedRedFlag'
  | 'aiFalseSignal'
  | 'contextOutsidePage'
  | 'edgeCaseNotInRubric'
  | 'borderline';

export type DecisionStatus = 'active' | 'superseded';

export type PageModerationStatus = 'clean' | 'underReview' | 'blocked' | 'approved';

export type LockOutcome =
  | 'acquired'
  | 'alreadyHeldByCaller'
  | 'stolenFromStaleHolder'
  | 'heldByAnotherReviewer';

export const PAGE_SUBJECT_KINDS: readonly SubjectKind[] = [
  'fundraiserPage',
  'teamPage',
  'collectionPage',
] as const;

export const BLOB_SUBJECT_KINDS: readonly SubjectKind[] = ['blob'] as const;
